import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMMarkdownContainer from 'src/components/UI/atoms/ATMMarkdownContainer/ATMMarkdownContainer';
import ATMCheckbox from 'src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox';


type Props = {
  formikProps: FormikProps<any>;
  testAttemptedData: any;
};
const SingleViewForm = ({ testAttemptedData, formikProps }: Props) => {

  const { values, isSubmitting } = formikProps;

  const decodeHTMLEntities = (str: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  };
  return (
    <div className='w-[80%] mx-auto'>

      <div>
        {values?.response?.map((questions: any, index: any) => {
          return (
            <div className='rounded shadow my-4 py-2 px-4'>
              <div className='flex flex-col'>
                <span className='text-md font-semibold capitalize'> {questions?.question?.questionTitle} </span>
                <span>
                  <ATMMarkdownContainer markdown={questions?.question?.description} />
                </span>
              </div>
              <div className='flex justify-end  '>
                <div className='bg-slate-200 text-[12px]  rounded p-1 font-medium'>
                  {`${questions?.score}/ ${questions?.weightage}`}
                </div>
              </div>
              <div className=''>
                {questions?.question?.questionOption?.map((option: any) => {

                  const decodedOptionName = decodeHTMLEntities(option?.optionName);
                  const isStudentAnswer = questions?.studentAnswer?.some((answer: any) => decodeHTMLEntities(answer) === decodedOptionName);
                  return (
                    <div className='flex gap-1 items-center text-md'>
                      <div className='flex gap-1 items-center'>
                        <ATMCheckbox
                          extraClasses='text-lg py-0.5'
                          inputClasses='h-4 w-4'
                          checked={isStudentAnswer}
                          onChange={(checked) => {
                          }}
                        />
                        <ATMMarkdownContainer markdown={option?.optionName} />

                      </div>
                      {option?.isCorrect ?
                        <div className=' bg-green-100 text-green-700 text-[10px] rounded p-1'>
                          Correct Answer
                        </div>

                        : null}
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
      <div className="flex items-center justify-end w-full pt-4 sticky bottom-0 bg-white">
        <ATMLoadingButton
          isLoading={isSubmitting}
          type="submit"
          className="w-32"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  )
}

export default SingleViewForm